import { render, staticRenderFns } from "./RedencionForm.vue?vue&type=template&id=5f89f73e"
import script from "./RedencionForm.vue?vue&type=script&lang=js"
export * from "./RedencionForm.vue?vue&type=script&lang=js"
import style0 from "./RedencionForm.vue?vue&type=style&index=0&id=5f89f73e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports